import * as exercisesConstants from './exercises';
import * as kindsConstants from './kinds';
export const exercises = exercisesConstants;
export const kinds = kindsConstants;